import { BaseModel } from "sjs-base-model";

export default class ResponseRichiestaCedibilitaModel extends BaseModel {
    public readonly OperatoreInserimento: string = "";
    public readonly CodiceCategoriaPensione: string = "";
    public readonly NumeroCertificatoPensione: string = "";
    public readonly UOInserimento: string = "";
    public readonly PdfCedibilita: string = "";
    public readonly Stato: string | undefined = undefined;
    public readonly DataRichiesta: string = "";
    public readonly id: string = "";
    public readonly Ente: number = 0;
    public readonly CF: string = "";
    public readonly ChiavePensione: string = "";
    public readonly Nome: string = "";
    public readonly Cognome: string = "";
    public readonly DataNascita: string = "";
    public readonly CodiceSede: string = "";
    public readonly DenominazioneSede: string = "";
    public readonly IndirizzoSede: string = "";
    public readonly Importo: number = 0;
    public readonly DataUltimaRichiestaCedibilita: string | undefined = undefined;
    public readonly RichiedenteUltimaCedibilita: string | undefined = undefined;
    public readonly DataRilascio: string = "";
    public readonly Note: string = "";
    public readonly ProtocolloInps: string = "";
    public readonly CodErrore: string = "";
    public readonly DescrizioneErrore: string = "";
    public readonly ScadenzaAOI: string = "";
    public readonly DataScadenzaAOIAnno: string = "";
    public readonly DataScadenzaAOIMese: string = "";

    constructor(data: Partial<ResponseRichiestaCedibilitaModel>) {
        super();

        this.update(data);
    }
}
